<script module>
	export class IndividualInvoiceRecord {
		constructor(data) {
			this.dateCreated = data.dateCreated
				? new Date(data.dateCreated).toLocaleDateString("en-US").split("T")[0]
				: "";
			this.documentType = data.documentType;
			this.entryId = data.entryId;
			this.memberName = data.memberName;
		}
	}
</script>
